import React, { useState } from "react";
import commingSoon from "../../assets/images/comingsoon.png";

export default function CommingSoon() {
  return (
    <>
      <div className="no-access-string text-center">
        <div
          style={{
            backgroundColor: "#F5F5F5",
            display: "inline-block",
            padding: "10px",
          }}
        >
          <img
            className="coming-soon-image mx-auto"
            src={commingSoon}
            alt="Coming Soon"
          />
        </div>
      </div>
    </>
  );
}
